import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { CircularProgress, Typography, Container, Alert, Box } from "@mui/material";

const BACKEND_URL = process.env.REACT_APP_BACKEND;

export default function EmailConfirmPage() {
  const { email_token } = useParams();
  const [status, setStatus] = useState("loading");
  // "loading" | "success" | "error" | "expired"

  useEffect(() => {
    const verifyBooking = async () => {
      try {
        const requestData = {
          email_token: email_token
        }
        const res = await axios.post(`${BACKEND_URL}/api/bookings/verify`, requestData);
        console.log(JSON.stringify(res));
        if (res.status === 200) {
          if (res.data.alreadyVerified) {
            setStatus('alreadyVerified')
          } else {
            setStatus("success");
          }
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    };

    verifyBooking();
    console.log(status);
  }, [email_token]);

  return (
    <Container sx={{ textAlign: "center", mt: 8 }}>
      {status === "loading" && <CircularProgress />}

      {status === "success" && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="70vh"
          p={2}
          flexDirection='column'
        >
          <Alert severity="success">
            <Typography variant="h6">Broneering kinnitatud!</Typography>
            <Typography>Sinu broneering on edukalt kinnitatud.</Typography>
            <Typography>Võite selle akna sulgeda.</Typography>
          </Alert>
        </Box>
      )}

      {status === "alreadyVerified" && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="70vh"
          p={2}
          flexDirection='column'
        >
          <Alert severity="warning">
            <Typography variant="h6">Broneering on juba kinnitatud</Typography>
            <Typography>Sinu broneering on juba selle lingi kaudu kinnitatud.</Typography>
          </Alert>
        </Box>
      )}

      {status === "error" && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="70vh"
          p={2}
          flexDirection='column'
        >
          <Alert severity="error">
            <Typography variant="h6">Tekkis viga</Typography>
            <Typography>Broneeringut ei õnnestunud kinnitada.</Typography>
          </Alert>
        </Box>
      )}
    </Container>
  );
}